module.exports = __webpack_public_path__ + "assets/img/free_2.679d7a28.png";